import React from "react";

function CircuitBackground() {
  return (
    <div className="circuit-bg" aria-hidden="true">
      <svg
        className="circuit-svg"
        viewBox="0 0 1600 1000"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          {/* Circuit trace paths */}
          <path id="trace1" d="M0 140 H420 L470 190 H820 L860 150 H1600" />
          <path id="trace2" d="M0 320 H260 L310 370 H700 L740 330 H1180 L1220 370 H1600" />
          <path id="trace3" d="M0 500 H180 L230 550 H540 L580 510 H960 L1000 550 H1600" />
          <path id="trace4" d="M0 680 H360 L400 720 H820 L860 680 H1240 L1280 720 H1600" />
          <path id="trace5" d="M0 860 H500 L540 820 H980 L1020 860 H1600" />
          <path id="traceV1" d="M240 0 V220 L200 260 V520 L240 560 V1000" />
          <path id="traceV2" d="M760 0 V180 L800 220 V460 L760 500 V1000" />
          <path id="traceV3" d="M1240 0 V300 L1200 340 V620 L1240 660 V1000" />
        </defs>

        {/* Static Traces */}
        <use href="#trace1" className="circuit-trace" />
        <use href="#trace2" className="circuit-trace" />
        <use href="#trace3" className="circuit-trace" />
        <use href="#trace4" className="circuit-trace" />
        <use href="#trace5" className="circuit-trace" />
        <use href="#traceV1" className="circuit-trace" />
        <use href="#traceV2" className="circuit-trace" />
        <use href="#traceV3" className="circuit-trace" />

        {/* Animated Packets */}
        <use href="#trace1" className="circuit-packet" />
        <use href="#trace2" className="circuit-packet p2" />
        <use href="#trace3" className="circuit-packet p3" />
        <use href="#trace4" className="circuit-packet p4" />
        <use href="#trace5" className="circuit-packet p5" />
        <use href="#traceV1" className="circuit-packet p2" />
        <use href="#traceV2" className="circuit-packet p6" />
        <use href="#traceV3" className="circuit-packet p3" />

        {/* Nodes */}
        <circle cx="470" cy="190" r="4" className="circuit-node" />
        <circle cx="820" cy="190" r="4" className="circuit-node n2" />
        <circle cx="310" cy="370" r="4" className="circuit-node n3" />
        <circle cx="740" cy="330" r="4" className="circuit-node n4" />
        <circle cx="1220" cy="370" r="4" className="circuit-node" />
        <circle cx="230" cy="550" r="4" className="circuit-node n2" />
        <circle cx="580" cy="510" r="4" className="circuit-node n3" />
        <circle cx="1000" cy="550" r="4" className="circuit-node" />
        <circle cx="400" cy="720" r="4" className="circuit-node n4" />
        <circle cx="860" cy="680" r="4" className="circuit-node n2" />
        <circle cx="1280" cy="720" r="4" className="circuit-node" />
        <circle cx="540" cy="820" r="4" className="circuit-node n3" />
        <circle cx="1020" cy="860" r="4" className="circuit-node n2" />

        {/* Chipsets */}
        <g opacity="0.35">
          <rect
            x="720"
            y="440"
            width="160"
            height="120"
            fill="none"
            stroke="#0bc4be"
            strokeWidth="1.2"
          />
          <rect
            x="740"
            y="460"
            width="120"
            height="80"
            fill="none"
            stroke="#00ccff"
            strokeWidth="0.8"
          />
          <text
            x="800"
            y="508"
            textAnchor="middle"
            fill="#00ccff"
            fontSize="10"
            fontFamily="monospace"
            opacity="0.7"
          >
            SoC-A17
          </text>

          <rect
            x="180"
            y="220"
            width="80"
            height="60"
            fill="none"
            stroke="#0bc4be"
            strokeWidth="1"
          />

          <rect
            x="1260"
            y="620"
            width="100"
            height="70"
            fill="none"
            stroke="#0bc4be"
            strokeWidth="1"
          />

          <rect
            x="1280"
            y="640"
            width="60"
            height="30"
            fill="none"
            stroke="#00ccff"
            strokeWidth="0.8"
          />
        </g>

        {/* Oscilloscope Waves */}
        <path
          className="circuit-wave"
          d="M0 940 Q40 900 80 940 T160 940 T240 940 T320 940 L360 940 L380 900 L400 980 L420 940 L1600 940"
        />

        <path
          className="circuit-wave w2"
          d="M0 60 L400 60 L420 20 L440 100 L460 60 Q500 20 540 60 T620 60 T700 60 L1200 60 L1220 20 L1240 100 L1260 60 L1600 60"
        />
      </svg>

      <div className="scan"></div>
    </div>
  );
}

export default CircuitBackground;